import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService implements OnDestroy {
  private baseUrl = environment.websocket_host;
  connection$: WebSocketSubject<any>;
  RETRY_SECONDS = 10;

  constructor(protected authService: AuthService) { }

  connect(url: string): Observable<any> {
    const wsUrl = this.baseUrl + url;
    if (!this.authService.isAuthenticated) {
      this.authService.logout(true);
      return;
    }
    if (this.connection$) {
      return this.connection$;
    } else {
      this.connection$ = webSocket(wsUrl + `?token=${this.authService.getToken()}`);
      return this.connection$;
    }
  }

  closeConnection() {
    if (this.connection$) {
      this.connection$.complete();
      this.connection$ = null;
    }
  }

  ngOnDestroy() {
    this.closeConnection();
  }

  sendMessage(msg: any) {
    this.connection$.next(msg);
  }

  updateTyping(content: any) {
    this.connection$.next(content);
  }
}